import { AccountId, LibraryResource } from "@ollie-sports/models";
import _ from "lodash";
import { getUniversalHelpers } from "../../helpers";
import { DistributiveOmit } from "../../utils/object-keys";

export async function libraryResource__client__updateLibraryResource(p: {
  libraryResource: LibraryResource;
  updatedByAccountId: AccountId;
}) {
  const { ollieFirestoreV2: h } = getUniversalHelpers();

  const id = h.LibraryResource.generateId();
  const nowMS = Date.now();
  await h.LibraryResource.set({
    id: p.libraryResource.id,
    doc: _.cloneDeep({ ...p.libraryResource, updatedAtMS: nowMS, updatedByAccountId: p.updatedByAccountId })
  });
}

// i18n certified - complete
